module.exports = __webpack_public_path__ + "img/Vend.2e1711c9.svg";